<template>
  <div>
    <!-- 基本信息 -->
    <div class="Minister-top information">
      <div class="Minister-top-top Ministerbackground">
        <div class="Minister-top-left Minister-top-color">变体设置</div>
        <div class="bianti_desc">（价格为全球商品价格,仅填写国内成本即可）</div>
      </div>
      <div class="information_content">
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: space-between;
            font-size: 16px;
          "
        >
          <div style="display: flex">
            <div style="width: 100px; font-size: 16px">
              <span style="color: red; margin-left: 12px">*</span>
              库存单位
            </div>
            <div class="input_el input_span">
              <div class="newipt" style="display: flex">
                <el-select
                  :disabled="isChakan || system < 5"
                  v-model="kucundanwei"
                  class="width87"
                  placeholder="请选择"
                >
                  <el-option label="UNIT" value="UNIT"></el-option>
                  <el-option label="PAIR" value="PAIR"></el-option>
                  <el-option label="SET" value="SET"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="system == 5 && !isChakan">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addItem"
              v-if="!onlineEdit"
              >添加一行</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addPiliang"
              v-if="headerList.length > 0 && !onlineEdit"
              >批量添加</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="removeAll"
              v-if="!onlineEdit"
              >批量移除</el-button
            >
          </div>
        </div>

        <!-- 头部 -->
        <el-table
          :row-class-name="tableRowClassName"
          :data="tableList"
          style="width: 100%; margin-top: 6px"
          v-loading="load_data"
          element-loading-text="拼命加载中"
          border
          :key="keyNum"
          @selection-change="on_batch_select"
          :header-cell-style="iscenter"
        >
          <!-- :cell-style="style" -->
          <el-table-column
            v-if="system == 5 && !isChakan"
            width="50"
            type="selection"
            fixed
            align="center"
          ></el-table-column>
          <el-table-column
            min-width="100"
            width="110"
            label="产品图"
            align="center"
            prop="imageList"
            fixed
          >
            <template slot-scope="scope">
              <template
                v-if="scope.row.imageList && scope.row.imageList.length > 0"
              >
                <el-popover trigger="hover" placement="right" :open-delay="600">
                  <img :src="scope.row.imageList[0]" class="prduct_img" alt />
                  <div slot="reference">
                    <img
                      class="item_image_box2"
                      :src="scope.row.imageList[0]"
                      @click="selectOnePicture(scope)"
                      alt
                    />
                  </div>
                </el-popover>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    :src="urlDHImg"
                    class="item_img_ipput"
                    v-if="system == 5 && !isChakan"
                    alt
                  />
                </el-tooltip>
              </template>
              <template v-else>
                <el-button
                  :disabled="system < 5 || isChakan"
                  @click="selectOnePicture(scope)"
                  >选择图片</el-button
                >
              </template>
              <!--              <template v-if="scope.row.imageList && scope.row.imageList.length">-->
              <!--                <div class="table_image_box">-->
              <!--                  <el-tooltip placement="bottom" effect="light" v-for="(item,index2) in scope.row.imageList" :key="index2" v-if="index2 < 2 && system == 5 && !isChakan">-->
              <!--                    <div class="image_input_tip_slot" slot="content">-->
              <!--                      <div class="item_click_slot" v-for="(itemHeader,index) in headerList" @click="hangdeYingyong(scope,index)">数据应用到-同{{itemHeader.nameCn}}</div>-->
              <!--                    </div>-->
              <!--                    <img class="item_image_box" :src="item" alt @click="shouImage(scope.row.imageList)"/>-->
              <!--                  </el-tooltip>-->
              <!--                  <div v-for="(item,index2) in scope.row.imageList" :key="index2" v-if="index2 < 2 && (system < 5 || isChakan)">-->
              <!--                    <img class="item_image_box" :src="item" alt @click="shouImage(scope.row.imageList)"/>-->
              <!--                  </div>-->
              <!--                  <div style="display: flex;align-items: center;justify-content: center;border: 1px solid darkgrey;cursor: pointer" class="item_image_box" @click="Select_pictures(scope.row)" v-if="system == 5 && !isChakan">-->
              <!--                    <i class="el-icon-plus" style="font-size: 22px"></i>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-else>-->
              <!--                <el-button-->
              <!--                    :disabled="system < 5 || isChakan"-->
              <!--                    @click="Select_pictures(scope.row)"-->
              <!--                >选择图片</el-button-->
              <!--                >-->
              <!--              </template>-->
            </template>
          </el-table-column>
          <el-table-column fixed min-width="220">
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">
                <span class="item_bitian">*</span>标题
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="YijianBiaoti(scope)"
                  v-if="system == 5 && !isChakan"
                  >一键生成</el-link
                >
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                maxlength="75"
                :disabled="system < 5 || isChakan"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="SKU" fixed min-width="220">
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">
                <span class="item_bitian">*</span>SKU编号
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickYijian(scope)"
                  v-if="system == 5 && !isChakan"
                  >一键生成</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.SKU"
                :disabled="system < 5 || isChakan"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column
            label="库存"
            prop="kucun"
            fixed
            width="80"
            show-overflow-tooltip
          >
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">
                <span class="item_bitian">*</span>库存
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <div class="image_input">
                <el-input
                  v-model="scope.row.kucun"
                  @focus="handleFocus(scope)"
                  :disabled="system < 5 || isChakan"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                >
                </el-input>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    v-show="
                      tableList[scope.$index].isShowImage &&
                      scope.column.property == fouceFiled
                    "
                    :src="urlDHImg"
                    class="item_img_ipput"
                    alt
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="bolanPrice"
            min-width="110"
            width="110"
            show-overflow-tooltip
          >
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">
                <span class="item_bitian">*</span>波兰站售价(PLN)
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickDingjia(scope)"
                  v-if="system == 5 && !isChakan"
                  >定价计算</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <div class="image_input">
                <el-input
                  v-model="scope.row.bolanPrice"
                  @focus="handleFocus(scope)"
                  :disabled="system < 5 || isChakan"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"
                >
                </el-input>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    v-show="
                      tableList[scope.$index].isShowImage &&
                      scope.column.property == fouceFiled
                    "
                    :src="urlDHImg"
                    class="item_img_ipput"
                    alt
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="jiekeshoujia"
            width="110"
            show-overflow-tooltip
          >
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">捷克站售价(CZK)</div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHuansuan(scope)"
                  v-if="system == 5 && !isChakan"
                  >自动换算</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <div class="image_input">
                <el-input
                  v-model="scope.row.jiekeshoujia"
                  @focus="handleFocus(scope)"
                  :disabled="system < 5 || isChakan"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"
                >
                </el-input>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    v-show="
                      tableList[scope.$index].isShowImage &&
                      scope.column.property == fouceFiled
                    "
                    :src="urlDHImg"
                    class="item_img_ipput"
                    alt
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="siluofake" width="110" show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">斯洛伐克售价(EUR)</div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHuansuan(scope)"
                  v-if="system == 5 && !isChakan"
                  >自动换算</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <div class="image_input">
                <el-input
                  v-model="scope.row.siluofake"
                  @focus="handleFocus(scope)"
                  :disabled="system < 5 || isChakan"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"
                >
                </el-input>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    v-show="
                      tableList[scope.$index].isShowImage &&
                      scope.column.property == fouceFiled
                    "
                    :src="urlDHImg"
                    class="item_img_ipput"
                    alt
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="xylshoujia" width="110" show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">匈牙利售价(HUF)</div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHuansuan(scope)"
                  v-if="system == 5 && !isChakan"
                  >自动换算</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <div class="image_input">
                <el-input
                  v-model="scope.row.xylshoujia"
                  @focus="handleFocus(scope)"
                  :disabled="system < 5 || isChakan"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"
                >
                </el-input>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    v-show="
                      tableList[scope.$index].isShowImage &&
                      scope.column.property == fouceFiled
                    "
                    :src="urlDHImg"
                    class="item_img_ipput"
                    alt
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="color_pattern"
            width="110"
            show-overflow-tooltip
          >
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">color/pattern</div>
              <!--              <div class="item_header_title"><el-link type="primary" @click="clickYijianColor(scope)" v-if="system == 5 && !isChakan">一键生成</el-link></div>-->
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickHeader(scope)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
              <div class="item_header_title">
                <el-link
                  type="primary"
                  @click="clickTongyanse(scope)"
                  v-if="system == 5 && !isChakan"
                  >同颜色</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <div class="image_input">
                <el-input
                  v-model="scope.row.color_pattern"
                  :disabled="system < 5 || isChakan"
                >
                </el-input>
                <el-tooltip placement="bottom" effect="light">
                  <div class="image_input_tip_slot" slot="content">
                    <div
                      class="item_click_slot"
                      v-for="(itemHeader, index) in headerList"
                      @click="hangdeYingyong(scope, index)"
                    >
                      数据应用到-同{{ itemHeader.cnName }}
                    </div>
                  </div>
                  <img
                    v-show="
                      tableList[scope.$index].isShowImage &&
                      scope.column.property == fouceFiled
                    "
                    :src="urlDHImg"
                    class="item_img_ipput"
                    alt
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-for="(item, index) in headerList"
            :key="item.id"
            :fixed="item.parameterId == '225693' || item.name == 'Kolor'"
            min-width="160"
          >
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">
                <div style="word-wrap: break-word">
                  <span class="item_bitian" v-if="item.required == 1">*</span>
                  {{ item.name }}({{ item.cnName }})
                </div>
              </div>
              <div
                class="item_header_title"
                v-if="item.parameterId != '225693'"
              >
                <el-link
                  type="primary"
                  @click="clickHeader2(index)"
                  v-if="system == 5 && !isChakan"
                  >同首行</el-link
                >
              </div>
              <div
                class="item_header_title"
                v-if="item.parameterId != '225693'"
              >
                <el-link
                  type="primary"
                  style="color: red"
                  @click="yichu(item, index)"
                  v-if="
                    !(item.options && item.options.variantsAllowed) &&
                    system == 5 &&
                    !isChakan
                  "
                  >移除</el-link
                >
              </div>
              <div
                class="item_header_title"
                v-if="item.parameterId == '225693'"
              >
                <el-link
                  type="primary"
                  @click="clickQingkong(index)"
                  v-if="system == 5 && !isChakan"
                  >清空</el-link
                >
              </div>
              <div
                class="item_header_title"
                v-if="item.parameterId == '225693'"
              >
                <el-link
                  type="primary"
                  @click="clickYijianEan(index)"
                  v-if="system == 5 && !isChakan"
                  >一键生成</el-link
                >
              </div>
            </template>
            <template slot-scope="scope">
              <el-input
                v-if="item.type == 'integer'"
                class="shuxing_input"
                v-model="attrErweiList[scope.$index][index].value"
                clearable
                :disabled="system < 5 || isChakan"
                oninput="value=value.replace(/[^0-9]/g,'')"
              >
              </el-input>
              <el-input
                v-else-if="item.type == 'float'"
                class="shuxing_input"
                v-model="attrErweiList[scope.$index][index].value"
                :disabled="system < 5 || isChakan"
                clearable
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"
              >
              </el-input>
              <el-select
                filterable
                clearable
                v-else-if="item.type == 'dictionary'"
                :multiple="
                  item.restrictions && item.restrictions.multipleChoices
                "
                v-model="attrErweiList[scope.$index][index].value"
                class="shuxing_select"
                :disabled="system < 5 || isChakan"
              >
                <el-option
                  v-for="itemselect in item.parameterDictionaryList"
                  :key="itemselect.value"
                  :label="itemselect.label"
                  :value="itemselect.value"
                ></el-option>
              </el-select>
              <el-input
                v-else
                class="shuxing_input"
                clearable
                v-model="attrErweiList[scope.$index][index].value"
                :disabled="system < 5 || isChakan"
              >
              </el-input>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            width="90"
            align="center"
            show-overflow-tooltip
            v-if="system == 5 && !isChakan"
          >
            <template slot="header" slot-scope="scope">
              <div class="item_header_title">操作</div>
            </template>
            <template slot-scope="scope">
              <el-button
                v-if="tableList.length > 1 && !onlineEdit"
                type="danger"
                @click="removeItem(scope)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <dingjia
      ref="dingjia"
      @changeReamrk="changeReamrk"
      @changeDingjia="changeDingjia"
    />
    <el-dialog
      title="选择图片"
      :modal-append-to-body="false"
      append-to-body
      :visible.sync="dialogFormVisible"
      width="1000px"
      @close="variantSelectImgDialogClose"
    >
      <el-alert
        title="变体图片最多选择15张"
        type="error"
        :closable="false"
      ></el-alert>
      <div
        style="display: flex; flex-wrap: wrap; margin-top: 5px; width: 950px"
      >
        <div
          style="position: relative; margin: 5px"
          v-for="(item, index) in imgSelectList"
          :key="index"
          class="option"
          @click="changeVariantSelectImg(item, index)"
        >
          <div
            class="img-mask"
            v-if="variantCheckedImgUidList.some((key) => key === item)"
          >
            <i class="el-icon-upload-success el-true-check">
              {{ getVariantSelectImgIndex(item) }}
            </i>
          </div>
          <img :src="item" alt />
        </div>
      </div>

      <el-divider
        v-if="imgSelectList.length && imgSelectList.length > 0"
        style="margin-top: -10px"
      ></el-divider>
      <el-upload
        :action="upload_url"
        accept="image/gif, image/jpeg, image/tiff"
        drag
        multiple
        list-type="picture-card"
        :on-success="onSuccess"
        :show-file-list="false"
        :on-remove="handleRemove"
        :headers="customHeaders"
      >
        <i class="el-icon-upload"></i>

        <div class="el-upload__text">
          <span>将文件拖到此处，或</span>
          <em>选择图片</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          只能上传JPG/PNG文件，且不超过2M
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="saveVariantSelectImg()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="批量添加"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      append-to-body
      width="1200px"
      top="6vh"
    >
      <div class="shuxing_box">
        <div
          class="item_shuxing"
          v-for="(item, index) in headerList2"
          :key="index"
          v-if="item.parameterId != '225693'"
        >
          <div class="shuxing_label">
            <span class="shuxing_label_bitian" v-if="item.required">*</span>
            {{ item.name }}（{{ item.cnName }})
          </div>
          <el-input
            class="shuxing_input"
            v-model="item.fieldValue"
            v-if="item.type != 'dictionary'"
          >
          </el-input>
          <el-select
            filterable
            v-if="item.type == 'dictionary'"
            multiple
            v-model="item.fieldValue"
            class="shuxing_select"
            clear
            filterable
          >
            <el-option
              v-for="itemselect in item.parameterDictionaryList"
              :key="itemselect.value"
              :label="itemselect.label"
              :value="itemselect.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" style="margin-top: 60px">
        <el-button type="primary" @click="queren" :loading="isLoading"
          >确 认</el-button
        >
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="已选图片"
      :visible.sync="dialogImageVisible"
      :modal-append-to-body="false"
      append-to-body
      width="1100px"
      top="6vh"
    >
      <div
        style="display: flex; flex-wrap: wrap; margin-top: 5px; width: 1050px"
      >
        <div
          style="position: relative; margin: 5px"
          v-for="(item, index) in biantiImgList"
          :key="index"
          class="option"
          @click="changeVariantSelectImg(item, index)"
        >
          <img :src="item" alt />
        </div>
      </div>
      <span slot="footer" style="margin-top: 60px">
        <el-button type="primary" @click="dialogImageVisible = false"
          >确 认</el-button
        >
        <el-button @click="dialogImageVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <xuanze-img
      v-model="xuanzeShow"
      :img-list="imgSelectList"
      @confirm="onConfirmByXuanzeImg"
    ></xuanze-img>
  </div>
</template>
<script>
import dingjia from "./dingjia.vue";
// import { v4 as uuidv4 } from 'uuid';
import { Baseurl, ajaxGet } from "@/api/api/api";
import { ajaxPost } from "../../../api/api/api";
import XuanzeImg from "./xuanzeImg.vue";
export default {
  name: "biantiComp",
  components: {
    XuanzeImg,
    dingjia,
  },
  props: {
    imgSelectList: {
      type: Array,
      default() {
        return [];
      },
    },
    isChakan: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      companyId: "",
      keyNum: 0,
      xuanzeShow: false,
      kucundanwei: "UNIT",
      itemTableObj: {
        id: null,
        imageList: [],
        name: "",
        SKU: "",
        kucun: "",
        bolanPrice: undefined,
        jiekeshoujia: undefined,
        siluofake: undefined,
        xylshoujia: undefined, //匈牙利售价
        color_pattern: undefined,
        isShowImage: false, //是否展示输入框按钮
      },
      biantiImgList: [],
      //在线产品编辑
      dialogImageVisible: false,
      variantCheckedImgUidList: [],
      //在线产品编辑
      onlineEdit: false,
      isLoading: false,
      dingjiaStatus: "",
      //批量添加
      dialogVisible: false,
      ParentSKU: "",
      ParentName: "",
      //二维的数组
      attrErweiList: [],
      batch_select: [],
      //点击所选变体对象  不能删啊
      selectBiantiRow: {},
      dialogFormVisible: false, //选择图片
      upload_url: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      fouceFiled: "",
      //导航图标的地址
      urlDHImg: require("@/assets/images/daohang.png"),
      biaohongList: [],
      tableList: [],
      load_data: false,
      iscenter: {
        textAlign: "center",
        background: "#f8f8f8",
        color: "#232323",
      },
      //表头数据
      headerList: [],
      //批量添加
      headerList2: [],
      //编辑状态保存的变体信息
      oldTableList: [],
      //捷克与波兰的汇率比
      jiekehuilv: 1,
      //斯洛伐克与波兰的汇率比
      siluofakehuilv: 1,
      //匈牙利的汇率比
      xylhuilv: 1,
    };
  },
  created() {
    this.companyId = JSON.parse(localStorage.getItem("role")).company_id;
    this.dingjiaStatus = "";
  },
  methods: {
    initData() {
      this.ParentSKU = undefined;
      this.ParentName = undefined;
      this.tableList = [{ ...this.itemTableObj }];
      this.headerList = [];
      this.attrErweiList = [];
      this.getBizhong();
    },
    //编辑或者查看的时候,给变体列表赋值
    setBianjiArr(headerList, allegroOfferList) {
      let that = this;
      this.headerList = [];
      this.attrErweiList = [];
      this.kucundanwei =
        allegroOfferList &&
        allegroOfferList[0] &&
        allegroOfferList[0].stock &&
        allegroOfferList[0].stock.unit
          ? allegroOfferList[0].stock.unit
          : "UNIT";
      let tablelist = allegroOfferList.map((item) => {
        return {
          id: item.id,
          imageList: item.imageList ? item.imageList : [],
          name: item.name,
          SKU: item.sku,
          kucun: item.stock ? item.stock.available : "",
          bolanPrice:
            item.sellingMode && item.sellingMode.price
              ? item.sellingMode.price.amount
              : "",
          jiekeshoujia: that.returnJiekePrice(item, "allegro-cz"),
          siluofake: that.returnJiekePrice(item, "allegro-sk"),
          xylshoujia: that.returnJiekePrice(item, "allegro-hu"),
          color_pattern: item.colorPattern,
          isShowImage: false, //是否展示输入框按钮
        };
      });

      let attrErweiList = [];
      tablelist.forEach((item) => {
        let itemArr = [];
        headerList.forEach((itemHeader) => {
          let itemObj;
          if (
            itemHeader.type == "dictionary" &&
            itemHeader.restrictions &&
            itemHeader.restrictions.multipleChoices
          ) {
            itemObj = {
              value: [],
            };
          } else {
            itemObj = {
              value: undefined,
            };
          }
          itemArr.push(itemObj);
        });
        attrErweiList.push(itemArr);
      });

      let newAttrErweiList = [...attrErweiList];
      attrErweiList.forEach((item, index) => {
        item.forEach((twoItem, twoIndex) => {
          // console.log(index)
          // console.log(allegroOfferList[index].productParameters)
          let haveValueForHeader = allegroOfferList[
            index
          ].productParameters.find(
            (itemFind) => itemFind.id == headerList[twoIndex].parameterId
          );

          if (haveValueForHeader) {
            if (headerList[twoIndex].type == "dictionary") {
              //多选
              if (
                headerList[twoIndex].restrictions &&
                headerList[twoIndex].restrictions.multipleChoices
              ) {
                let valueObj = {
                  value: JSON.parse(
                    JSON.stringify(haveValueForHeader.valuesIds)
                  ),
                };
                newAttrErweiList[index][twoIndex] = { ...valueObj };
              } else {
                let valueObj = {
                  value: JSON.parse(
                    JSON.stringify(haveValueForHeader.valuesIds[0])
                  ),
                };
                newAttrErweiList[index][twoIndex] = { ...valueObj };
              }
            } else {
              let valueObj = {
                value: JSON.parse(JSON.stringify(haveValueForHeader.values[0])),
              };
              newAttrErweiList[index][twoIndex] = { ...valueObj };
            }
          }
        });
      });
      this.headerList = [...headerList];
      this.tableList = [...tablelist];
      this.attrErweiList = [...newAttrErweiList];
    },
    //这个接口的list 存放遍历后的变体列
    setBiantiList(list) {
      this.biaohongList = [];
      this.headerList = [...list];
      let itemArr = this.headerList.map((item) => {
        let itemObj = {
          value: undefined,
        };
        if (
          item.type == "dictionary" &&
          item.restrictions &&
          item.restrictions.multipleChoices
        ) {
          itemObj.value = [];
        }
        return itemObj;
      });
      this.tableList.forEach((item) => {
        let newItemArr = JSON.parse(JSON.stringify(itemArr));
        this.attrErweiList.push(newItemArr);
      });
    },
    addItem() {
      if (this.headerList.length > 0) {
        let itemArr = this.headerList.map((item) => {
          let itemObj = {
            value: undefined,
          };
          if (
            item.type == "dictionary" &&
            item.restrictions &&
            item.restrictions.multipleChoices
          ) {
            itemObj.value = [];
          }
          return itemObj;
        });
        this.attrErweiList.push(itemArr);
      }
      let itemObj = { ...this.itemTableObj };
      this.tableList.push(itemObj);
    },
    on_batch_select(val) {
      this.batch_select = val;
    },
    //定价计算
    clickDingjia(scope) {
      if (this.dingjiaStatus != "click") {
        this.dingjiaStatus = "click";
        this.$refs.dingjia.dialogVisible = true;
        this.$refs.dingjia.resetDingjia();
      } else {
        this.$refs.dingjia.dialogVisible = true;
      }
    },
    //同首行
    clickHeader(scope) {
      let property = scope.column.property;
      this.tableList.forEach((item) => {
        item[property] = this.tableList[0][property];
      });
    },
    //清空
    clickQingkong(index) {
      this.attrErweiList.forEach((item) => [(item[index].value = undefined)]);
    },
    //变体属性同首行
    clickHeader2(index) {
      this.attrErweiList.forEach((item) => {
        item[index].value = this.attrErweiList[0][index].value;
      });
    },

    roundDownToNearestFiveOrZero(num) {
      // 向下取整
      let floored = Math.ceil(num);

      // 获取最后一位
      let lastDigit = floored % 10;

      // 如果最后一位不是 0 或 5，调整到最近的 0 或 5
      if (lastDigit < 5) {
        return floored - lastDigit; // 调整到下一个 0
      } else {
        return floored - lastDigit + 5; // 调整到下一个 5
      }
    },
    //自动换算
    clickHuansuan(scope) {
      let property = scope.column.property;
      this.tableList.forEach((item) => {
        if (item.bolanPrice) {
          if (property == "siluofake") {
            item.siluofake = (item.bolanPrice * this.siluofakehuilv).toFixed(2);
          } else if (property == "jiekeshoujia") {
            item.jiekeshoujia = (item.bolanPrice * this.jiekehuilv).toFixed(2);
          } else if (property === "xylshoujia") {
            item.xylshoujia = this.roundDownToNearestFiveOrZero(
              item.bolanPrice * this.xylhuilv
            );
          }
        }
      });
    },
    //一键生成颜色
    clickYijianColor(scope) {
      let newTableList = JSON.parse(JSON.stringify(this.tableList)).map(
        (item) => {
          if (item.imageList && item.imageList.length > 0) {
            item.imageList = JSON.stringify(item.imageList);
          } else {
            item.imageList = "zhanwei";
          }
          return item;
        }
      );
      let kongArr = [];
      let uuIdArr = [];
      newTableList.forEach((item, index) => {
        if (kongArr.includes(item.imageList)) {
          let newIndex = kongArr.findIndex((itemFind) => {
            return item.imageList == itemFind;
          });
          this.tableList[index].color_pattern = uuIdArr[newIndex];
        } else {
          // let groupId = uuidv4()
          this.tableList[index].color_pattern = groupId;
          uuIdArr.push(groupId);
          kongArr.push(item.imageList);
        }
      });
    },
    //一键生成ean
    clickYijianEan(index) {
      let params = {
        companyId: this.companyId,
        count: this.tableList.length,
      };
      const API = Baseurl + "allegroEan/getUsableEan";
      ajaxPost(API, params).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.attrErweiList.forEach((item, indexErwei) => {
            this.$set(item[index], "value", data[indexErwei]);
            // item[index].value = data[indexErwei]
          });
        }
      });
    },
    //获取汇率
    getBizhong() {
      const API = Baseurl + "rateController/getAllRate";
      ajaxPost(API).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          let jieke = 1;
          let siluofake = 1;
          let bolan = 1;
          let xyl = 1; //匈牙利
          data.forEach((item) => {
            if (item.currencyCode == "CZK") {
              jieke = item.exchangeRate;
            } else if (item.currencyCode == "EUR") {
              siluofake = item.exchangeRate;
            } else if (item.currencyCode == "PLN") {
              bolan = item.exchangeRate;
            } else if (item.currencyCode == "HUF") {
              xyl = item.exchangeRate;
            }
          });
          this.jiekehuilv = (bolan / jieke).toFixed(4);
          this.siluofakehuilv = (bolan / siluofake).toFixed(4);
          this.xylhuilv = (bolan / xyl).toFixed(4);
        }
      });
    },
    //一键生成标题
    YijianBiaoti() {
      if (!this.ParentName) {
        this.$message("请先输入父标题");
        return;
      }
      this.createName();
    },
    createName() {
      this.tableList = this.tableList.map((item, index) => {
        item.name = this.ParentName + this.returnBiaoti(index, "biaoti");
        return item;
      });
    },
    returnBiaoti(index, skuName) {
      let nameLength;
      if (skuName == "sku") {
        nameLength = 999;
      } else {
        nameLength = this.ParentName ? 75 - this.ParentName.length : 75;
      }
      let returnStr = "";
      if (this.attrErweiList.length > 0) {
        this.attrErweiList[index].forEach((item, arrIndex) => {
          //item是数组
          if (typeof item.value === "object" && Array.isArray(item.value)) {
            let str = "";
            if (item.value.length > 0) {
              item.value.forEach((itemValue) => {
                str = str + this.returnOptionsLabel(arrIndex, itemValue) + "/";
              });
            }
            returnStr = returnStr + "_" + str.slice(0, -1);
          } else {
            if (item.value) {
              if (this.headerList[arrIndex].type == "dictionary") {
                returnStr =
                  returnStr +
                  "_" +
                  this.returnOptionsLabel(arrIndex, item.value);
              } else {
                returnStr = returnStr + "_" + item.value;
              }
            }
          }
        });
      }
      if (returnStr.length > nameLength) {
        returnStr = "";
      }
      return returnStr;
    },
    //移除一个
    removeItem(scope) {
      if (scope.row.id) {
        this.$confirm("此操作将删除该变体, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              ids: [scope.row.id],
            };
            let apiUrl = "allegroOfferInfo/batchRemoveOffer";
            ajaxPost(Baseurl + apiUrl, params)
              .then((res) => {
                const { code, message, data } = res.data;
                if (code == 200) {
                  this.tableList.splice(scope.$index, 1);
                  this.attrErweiList.splice(scope.$index, 1);
                  this.$message.success("删除成功!");
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch(function (e) {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.tableList.splice(scope.$index, 1);
        this.attrErweiList.splice(scope.$index, 1);
      }
    },
    removeAll(value) {
      if (this.batch_select.length == 0) {
        return this.$alert("请至少勾选一项变体属性！", "提示", {
          confirmButtonText: "确定",
        });
      }
      if (this.batch_select.length == this.tableList.length) {
        return this.$alert("请至少保留一项变体属性！", "提示", {
          confirmButtonText: "确定",
        });
      }
      this.$confirm("此操作将删除勾选变体, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //存放移除的下标
          let arrList = [];
          let newArrIdList = [];
          (this.tableList = JSON.parse(
            JSON.stringify(
              this.tableList.filter((item, index) => {
                //相等说明对象
                let ss = this.batch_select.some((itemSome) => {
                  return item == itemSome;
                });
                if (ss) {
                  arrList.push(index);
                  if (item.id) {
                    newArrIdList.push(item.id);
                  }
                }
                return !ss;
              })
            )
          )),
            (this.attrErweiList = JSON.parse(
              JSON.stringify(
                this.attrErweiList.filter((item, index) => {
                  return !arrList.some((itemSome) => {
                    return index == itemSome;
                  });
                })
              )
            ));
          this.batch_select = [];
          if (newArrIdList && newArrIdList.length > 0) {
            this.deletePiLiangBianti(newArrIdList);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async deletePiLiangBianti(ids) {
      let params = {
        ids: ids,
      };
      let apiUrl = "allegroOfferInfo/batchRemoveOffer";
      await ajaxPost(Baseurl + apiUrl, params);
    },
    //聚焦后显示图片
    handleFocus(scope) {
      this.tableList.forEach((item, index) => {
        item.isShowImage = index == scope.$index;
      });
      this.fouceFiled = scope.column.property;
    },
    //数据批量应用
    hangdeYingyong(scope, index) {
      let value = this.attrErweiList[scope.$index][index].value;
      //记录下标
      let kongArr = [];
      this.attrErweiList.filter((item, atrIndex) => {
        if (
          item[index].value &&
          value &&
          item[index].value.toString() == value.toString()
        ) {
          kongArr.push(atrIndex);
        }
      });
      let value2 = scope.row[scope.column.property];
      kongArr.forEach((item) => {
        this.tableList[item][scope.column.property] = value2;
      });
    },
    // 选择图片
    // Select_pictures(row) {
    //   this.itemImageList = []
    //   this.dialogFormVisible = true
    //   this.selectBiantiRow = row
    // },
    //成功回调
    onSuccess(response, file, fileList) {
      this.$emit("addImageList", [file.response.data]);
    },

    // 删除图片
    handleRemove(file, fileList) {
      this.itemImageList = fileList.map((item) => {
        return item.response.data;
      });
    },

    // 选择图片确定
    saveVariantSelectImg() {
      this.selectBiantiRow.imageList = this.variantCheckedImgUidList;
      this.variantCheckedImgUidList = [];
      this.dialogFormVisible = false;
    },
    //必填没填返回true
    returnBitian() {
      return this.headerList.some((item, index) => {
        return (
          item.isRequired &&
          this.attrErweiList.some((itemsome) => {
            return itemsome[index].vallue == [] || !itemsome[index].vallue;
          })
        );
      });
    },
    returnOptionsLabel(index, value) {
      return this.headerList[index].parameterDictionaryList.filter((item) => {
        return item.value == value;
      })[0].pinjieName;
    },
    //一键生成
    clickYijian() {
      if (!this.ParentSKU) {
        this.$message("请先生成父SKU");
        return;
      }
      this.tableList.forEach((item, index) => {
        item.SKU = this.ParentSKU + this.returnBiaoti(index, "sku");
      });
      //ParentSKU
    },
    // 重复 true 不重复 false
    returnBianti() {
      if (this.headerList.length == 0) {
        return false;
      } else {
        let kongList = [];
        this.biaohongList = [];
        this.attrErweiList.forEach((item, index) => {
          if (
            kongList.some((itemSome, indexSome) => {
              return itemSome == JSON.stringify(item);
            })
          ) {
            kongList.forEach((itemEach, indexEach) => {
              if (itemEach == JSON.stringify(item)) {
                this.biaohongList[indexEach] = true;
              }
            });
            this.biaohongList.push(true);
          } else {
            this.biaohongList.push(false);
            kongList.push(JSON.stringify(item));
          }
        });
        return kongList.length != this.attrErweiList.length;
      }
    },
    //返回sku拼接
    returnSku(index) {
      let returnStr = "";
      if (this.attrErweiList.length > 0) {
        this.attrErweiList[index].forEach((item) => {
          //item是数组
          if (typeof item.value === "object" && Array.isArray(item.value)) {
            let str = "";
            if (item.value.length > 0) {
              item.value.forEach((itemValue) => {
                itemValue = !itemValue ? "no" : itemValue;
                str = str + itemValue + "/";
              });
            }
            returnStr = returnStr + "_" + str.slice(0, -1);
          } else {
            if (item.value) {
              returnStr = returnStr + "_" + item.value;
            }
          }
        });
      } else {
        returnStr = "";
      }
      return returnStr;
    },
    //批量添加
    addPiliang() {
      this.headerList2 = JSON.parse(
        JSON.stringify(
          this.headerList.map((item) => {
            if (item.type != "dictionary") {
              item.fieldValue = "";
            } else {
              item.fieldValue = [];
            }
            return item;
          })
        )
      );
      this.dialogVisible = true;
    },
    //确认
    queren() {
      this.isLoading = true;
      let newHeaderList2 = JSON.parse(JSON.stringify(this.headerList2));
      //筛选出填写有值的项
      let headerSureList = newHeaderList2.filter((item) => {
        let result;
        if (item.type == "dictionary") {
          result = item.fieldValue.length > 0;
        }
        if (item.type != "dictionary") {
          result = item.fieldValue ? true : false;
        }
        return result;
      });
      if (headerSureList.length == 0) {
        this.isLoading = false;
        return this.$message.warning("请至少输入/选择一项变体属性!");
      }

      let newSureList = newHeaderList2.map((item) => {
        //输入框
        if (item.type != "dictionary") {
          if (!item.fieldValue) {
            item.fieldValue = ["shanchu"];
          } else {
            item.fieldValue = item.fieldValue.split(",");
          }
        } else {
          if (item.fieldValue.length == 0) {
            item.fieldValue = ["shanchu"];
          }
        }
        return item.fieldValue;
      });
      let allLength = 1;
      for (let i = 0; i < newSureList.length; i++) {
        allLength = allLength * newSureList[i].length;
      }
      for (let i = 0; i < allLength; i++) {
        let itemTable = { ...this.itemTableObj };
        this.tableList.push(itemTable);
      }

      let newList = newSureList.reduce(
        (a, b) => {
          return a.flatMap((x) => b.map((y) => [...x, y]));
        },
        [[]]
      );
      let newAttrErweiList = newList.map((item, index) => {
        item = item.map((itemMap, mapIndex) => {
          if (itemMap == "shanchu") {
            itemMap = undefined;
          }
          let itemObj = {
            value: undefined,
          };
          if (
            newHeaderList2[mapIndex].type == "string" &&
            (itemMap || itemMap == "0")
          ) {
            itemObj.value = itemMap;
          } else if (
            newHeaderList2[mapIndex].type == "integer" &&
            (itemMap || itemMap == "0")
          ) {
            itemObj.value = parseInt(itemMap);
          } else if (
            newHeaderList2[mapIndex].type == "float" &&
            (itemMap || itemMap == "0")
          ) {
            itemObj.value = parseFloat(itemMap);
          } else if (
            newHeaderList2[mapIndex].type == "dictionary" &&
            (itemMap || itemMap == "0")
          ) {
            if (
              newHeaderList2[mapIndex].restrictions &&
              newHeaderList2[mapIndex].restrictions.multipleChoices
            ) {
              let newList = [];
              newList.push(itemMap);
              itemObj.value = newList;
            } else {
              itemObj.value = itemMap;
            }
          }
          return itemObj;
        });
        return item;
      });
      this.dialogVisible = false;
      this.isLoading = false;
      this.attrErweiList = this.attrErweiList.concat(newAttrErweiList);
      // 设置同颜色
      this.clickTongyanse();
    },
    changeReamrk(val) {
      this.$emit("changeReamrk", val);
    },
    changeDingjia(val) {
      this.tableList.forEach((item) => {
        item.bolanPrice = val;
      });
    },
    getVariantSelectImgIndex(item) {
      const isHaveIndex = this.variantCheckedImgUidList.findIndex(
        (key) => key === item
      );
      return isHaveIndex + 1;
    },
    changeVariantSelectImg(item) {
      if (this.variantCheckedImgUidList.length <= 0) {
        this.variantCheckedImgUidList.push(item);
      } else {
        const isHaveIndex = this.variantCheckedImgUidList.findIndex(
          (key) => key === item
        );

        if (isHaveIndex > -1) {
          this.variantCheckedImgUidList.splice(isHaveIndex, 1);
        } else {
          if (this.variantCheckedImgUidList.length < 15) {
            this.variantCheckedImgUidList.push(item);
          } else {
            this.$message.error("变体图片最多选择15张");
          }
        }
      }
    },
    variantSelectImgDialogClose() {
      this.variantCheckedImgUidList = [];
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.biaohongList.length > rowIndex && this.biaohongList[rowIndex]) {
        return "biaohong_table";
      } else {
        return "";
      }
    },
    shouImage(imgs) {
      if (imgs.length == 0) {
        return this.$message("暂无图片");
      }
      this.dialogImageVisible = true;
      this.biantiImgList = imgs;
    },
    selectOnePicture(scope) {
      console.log( scope.$index);
      
      this.selectImageIndex = scope.$index;
      this.xuanzeShow = true;
    },

    onConfirmByXuanzeImg(img) {
      let imglist = [];
      imglist.push(img);
      this.tableList[this.selectImageIndex].imageList = imglist;
      this.tableList = [...this.tableList];
      this.keyNum += 1;
    },
    //增加一个变体属性到列表表头
    addBianti(item) {
      this.attrErweiList = this.attrErweiList.map((itemArr) => {
        if (item.fieldValue) {
          itemArr.push({
            value: item.fieldValue,
          });
        } else {
          let itemObj = {
            value: undefined,
          };
          if (
            item.type == "dictionary" &&
            item.restrictions &&
            item.restrictions.multipleChoices
          ) {
            itemObj.value = [];
          }
          itemArr.push(itemObj);
        }
        return itemArr;
      });
      this.headerList.push(item);
    },
    //操作栏移除一行
    yichu(itemHeader, index) {
      let jsonItem = Object.assign({}, itemHeader);
      let newErwei = [...this.attrErweiList];
      let newHeaderList = [...this.headerList];
      if (newErwei.length > 0 && newErwei[0].length > 1) {
        if (
          jsonItem.type == "dictionary" &&
          jsonItem.restrictions &&
          jsonItem.restrictions.multipleChoices
        ) {
          jsonItem.fieldValue = [];
        } else {
          jsonItem.fieldValue = undefined;
        }
        newHeaderList.splice(index, 1);
        newErwei.forEach((itemArrer) => {
          itemArrer.splice(index, 1);
        });
        this.headerList = [];
        this.attrErweiList = [];
        setTimeout(() => {
          this.headerList = newHeaderList;
          this.attrErweiList = newErwei;
        }, 10);
        this.$emit("changeTopAttr", [jsonItem]);
      } else {
        this.attrErweiList = [];
        this.headerList = [];
      }
    },
    //同颜色
    clickTongyanse() {
      let colorIndex = this.headerList.findIndex((item) => {
        return item.name == "Kolor";
      });
      if (colorIndex != -1) {
        this.tableList.forEach((itemTable, tableIndex) => {
          if (this.attrErweiList[tableIndex][colorIndex].value) {
            itemTable.color_pattern = this.returnOptionsLabel(
              colorIndex,
              this.attrErweiList[tableIndex][colorIndex].value
            );
          }
        });
      }
    },
    //返回价格
    returnJiekePrice(item, name) {
      let returnStr = "";
      if (
        item &&
        item.additionalMarketplaces &&
        item.additionalMarketplaces[name] &&
        item.additionalMarketplaces[name].sellingMode &&
        item.additionalMarketplaces[name].sellingMode.price
      ) {
        returnStr = item.additionalMarketplaces[name].sellingMode.price.amount;
      }
      return returnStr;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../ozon.less";

::v-deep .el-upload__text {
  display: flex;
  flex-direction: column;
  color: #606266;
  font-size: 14px;
  position: absolute;
  top: 30px;
  width: 100%;
  height: 100%;

  em {
    margin-top: -90%;
  }
}

::v-deep .el-upload el-upload--picture-card {
  width: 110px;
  height: 110px;
}

::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
  border: none;
  position: relative;
}

.el_tip_box {
  width: 360px;
  font-size: 18px;
  background: rgb(39, 39, 39);
  border-radius: 10px;
  padding: 15px;
  color: whitesmoke;
}

.item_img {
  height: 16px;
  width: 16px;
  margin-left: 5px;
  cursor: pointer;
}

.image_input {
  position: relative;
}

.item_img_ipput {
  position: absolute;
  right: 5px;
  top: 6px;
  height: 20px;
  width: 20px;
  cursor: pointer;
}

.Minister-top {
  width: 99%;
  border-radius: 4px;
  overflow: hidden;

  .Ministerbackground {
    background: #d7f0dbff;
  }

  .Minister-top-top {
    width: 100%;
    height: 40px;

    .Minister-top-left {
      width: 80px;
      line-height: 40px;
      float: left;
      text-align: center;
      font-size: 16px;
      color: #fff;
    }

    .bianti_desc {
      line-height: 40px;
      font-size: 16px;
    }

    .Minister-top-color {
      // color: #567801;
      background: #39b54a;
    }
  }

  .information_content {
    width: calc(100% - 22px);
    overflow: hidden;
    padding: 10px 10px;
    border: 1px solid rgba(168, 168, 168, 0.8);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: none !important;
  }
}

.item_header_title {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .item_bitian {
    color: red;
  }
}

.image_input_tip_slot {
  .item_click_slot {
    font-size: 16px;
    padding: 0 10px;
    line-height: 30px;
    align-items: center;
    cursor: pointer;
  }

  .item_click_slot:hover {
    background: rgb(254, 225, 136);
  }
}

.table_image_box {
  display: flex;
  flex-wrap: nowrap;
}

.item_image_box {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  cursor: pointer;
}

.item_image_box2 {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.shuxing_box {
  border-radius: 10px;
  padding: 10px 0;
  font-size: 16px;

  .item_shuxing {
    display: flex;
    margin-bottom: 4px;

    .shuxing_label {
      width: 30%;
      text-align: right;
      padding: 3px 10px;

      .shuxing_label_bitian {
        color: red;
        margin-right: 4px;
      }
    }

    .shuxing_input {
      width: 60%;
    }

    .shuxing_select {
      width: 60%;
    }

    .shuxing_button {
      width: 30px;
      height: 30px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgb(255, 183, 82);
      color: white;
      font-weight: 700;
      font-size: 20px;
      margin-left: 10px;
    }
  }
}

.option {
  width: 148px;
  height: 148px;
  margin: 0 8px 8px 0;
  float: left;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  position: relative;

  .img-mask {
    position: absolute;
    right: -17px;
    top: -7px;
    width: 46px;
    height: 26px;
    background: #13ce66;
    text-align: center;
    transform: rotate(45deg);

    .el-true-check {
      color: #fff;
      font-size: 12px;
      margin-top: 12px;
      transform: rotate(-45deg);
    }
  }

  img {
    width: 146px;
  }
}

::v-deep .biaohong_table {
  background-color: oldlace !important;

  ::v-deep tr {
    background: none !important;
  }
}
</style>
